<template>
  <div class="page">
    <mobileHeader title="扫码" rightType="none" @back="JS.close()" />
    <div class="scanCode-icon">
      <!-- <img @click="scanCode" src="@/assets/images/djsm.png" alt="" />
      <div class="no-select" @click="$router.push('/flowPath/putOnRecord')">钢瓶建档入口</div>
      <div class="no-select" @click="$router.push('/flowPath/batchScanCode')">批量设置</div>
      <div class="no-select" v-if="userRole == 3" @click.once="loginOut">退出登录</div> -->
      <div class="no-select" @click="scanCode">单个扫码</div>
      <div class="no-select" @click="$router.push('/flowPath/batchScanCode')">批量扫码</div>
      <div class="no-select" @click="$router.push('/flowPath/putOnRecord')">钢瓶建档</div>
      <div class="no-select" v-if="userRole == 3" @click.once="loginOut">退出登录</div>
    </div>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import { Toast } from "vant";
export default {
  components: {
    mobileHeader,
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
  },
  methods: {
    scanCode() {
      this.mixScanCode(this.analysisCode);
    },
    async analysisCode({data}) {
      try{
        // return console.log(res.split('?bottleId=')[2],'123456')
        // const ret = JSON.parse(res.data);
        const ret = {
          bottleId: this.mixDecode(data)
        }
        if (!ret.bottleId)
          return Toast({ message: "请扫正确的二维码", duration: 1000 })
        this.$store.state.bottleId = ret.bottleId;
        if (this.userRole == 3) {
          const { code, msg } = await this.mixGetBottleInfo(null, 1);
          code == 200
            ? this.$router.push("/flowPath/collectNew?state=" + 1)
            : Toast({ message: msg, duration: 500 });
        } else {
          const { code, msg } = await this.mixGetBottleInfo(ret.bottleId);
          code == 200
            ? this.$router.push("/flowPath/index?bottleId=" + ret.bottleId)
            : Toast({ message: msg, duration: 500 });
        }
      }catch(error){
        return Toast({ message: "请扫正确的二维码!", duration: 500});
      }
    },
    loginOut(){
      JS.exit()
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
::v-deep .mobile-header{
  background: #ffffff00!important;
}
.page {
  width: 100vw;
  display: flex;
  background: #f7f7f7;
  height: auto;
  min-height: 100vh;
  width: 100vw;
  flex-direction: column;
  // background-image: url(../../../assets/images/Scan_code_bg.png);
  background-image: url(../../assets/images/Scan_code_bg.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  .scanCode-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 95vw;
    div{
      width: 90vw;
      height: 12vw;
      color: white;
      font-size: 4vw;
      border-radius: 1.5vw;
      display:flex;
      justify-content: center;
      align-items: center;
      margin-top: 6.5vw;
    }
    div:active{
      opacity: 0.5;
    }
    & > div:nth-child(1){
      background: #41c09e;
    }
    & > div:nth-child(2){
      background: #3fb9ff;
    }
    & > div:nth-child(3){
      background: #f3c46a;
    }
    & > div:nth-child(4){
      background: #ff7878;
    }
  }
}
</style>